module.exports = __webpack_public_path__ + "static/lets-work-together-305531c020d6cef6562d3fab94610f4f.mp4";